<template>
  <a-layout-footer style="text-align: center">
    <p>
      ©{{ this.data.config.Year }}- {{ this.data.config["Company Name"] }}. All rights reserved. <br>
      备案号：<a href="http://beian.miit.gov.cn/" target="_blank">{{ this.data.config.ICP }}</a>
    </p>
  </a-layout-footer>
</template>

<script>
import config from "@/config"

export default {
  name: "layout-footer",
  data() {
    return {
      data: {
        config: config,
      }
    }
  }
}
</script>

<style scoped>

</style>